import { Controller } from "@hotwired/stimulus"

// Updates a horizontal progress bar based on the page scroll position.
export default class extends Controller {
  static targets = ["bar"]

  connect() {
    this.boundUpdate = this.scheduleUpdate.bind(this)
    window.addEventListener("scroll", this.boundUpdate, { passive: true })
    window.addEventListener("resize", this.boundUpdate, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.boundUpdate)
    window.removeEventListener("resize", this.boundUpdate)
    cancelAnimationFrame(this.rafId)
  }

  scheduleUpdate() {
    cancelAnimationFrame(this.rafId)
    this.rafId = requestAnimationFrame(() => this.update())
  }

  update() {
    if (!this.hasBarTarget) return
    const docHeight = document.documentElement.scrollHeight - window.innerHeight
    const progress = docHeight > 0 ? Math.min(Math.max(window.scrollY / docHeight, 0), 1) : 0
    this.barTarget.style.transform = `scaleX(${progress})`
  }
}
